const OurValues = () => {
    const items = [
        { icon: "./assets/images/home/customer.png", label: "Customer First" },
        { icon: "./assets/images/home/integrity.png", label: "Integrity" },
        { icon: "./assets/images/home/expertise.png", label: "Expertise" },
        { icon: "./assets/images/home/proactive.png", label: "Proactiveness" },
        { icon: "./assets/images/home/reliability.png", label: "Reliability" },

        { icon: "./assets/images/home/innovation.png", label: "Innovation" },
        { icon: "./assets/images/home/teamwork.png", label: "Teamwork" },
        { icon: "./assets/images/home/communication.png", label: "Communication" },
        { icon: "./assets/images/home/respect.png", label: "Respect" },
        { icon: "./assets/images/home/community.png", label: "Community" },
    ];
    return (
        <>
            <section className="values-section">
                <div className='row center-heading'>
                    <div className='center-heading'>
                        <p className="heading-with-border" style={{marginBottom:'30px'}}>Our Values </p>
                    </div>
                </div>

                <div className="values-grid">
                    {items.map((item) => (
                        <div className="value-box" key={item.label}>
                            <img src={item.icon} alt={item.label} className="value-icon" />
                            <p>{item.label}</p>
                        </div>
                    ))}
                </div>
            </section>
        </>
    )
}

export default OurValues;      